import '../css/modal.css';
import './confirm.js';

(function ($) {
	'use strict';

	var MkUi = window.MkUi || {};
	var $placeholder = null;

	// Alert glyph shown at the top of confirm/alert dialogs.
	var ICON_ALERT =
		'<svg viewBox="0 0 24 24" width="24" height="24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false">' +
			'<circle cx="12" cy="12" r="9"></circle>' +
			'<line x1="12" y1="7.5" x2="12" y2="13"></line>' +
			'<circle cx="12" cy="16.4" r="0.7" fill="currentColor" stroke="none"></circle>' +
		'</svg>';

	function getPlaceholder() {
		if ($placeholder) return $placeholder;
		$placeholder = $(
			'<div id="mk-ui-modal">' +
				'<div class="mk-ui-modal__topbar">' +
					'<span class="mk-ui-modal__icon" aria-hidden="true">' + ICON_ALERT + '</span>' +
					'<button type="button" class="mk-ui-modal__close" aria-label="Close">×</button>' +
				'</div>' +
				'<div class="mk-ui-modal__body">' +
					'<h2 class="mk-ui-modal__title"></h2>' +
					'<div class="mk-ui-modal__content"></div>' +
				'</div>' +
				'<div class="mk-ui-modal__actions"></div>' +
			'</div>'
		);
		$('body').append($placeholder);
		// Our own close button dismisses the dialog (mirrors a Cancel).
		$placeholder.on('click', '.mk-ui-modal__close', function () {
			MkUi.modal.close();
		});
		return $placeholder;
	}

	function ensureDialog($p) {
		if ($p.hasClass('ui-dialog-content')) return;
		$p.dialog({
			autoOpen: false,
			modal: true,
			height: 'auto',
			minWidth: 300,
			resizable: false,
		});
	}

	MkUi.modal = {
		open: function (title, content, options) {
			options = options || {};
			var $p = getPlaceholder();
			ensureDialog($p);

			// Our own title heading (jQuery UI's titlebar is hidden via CSS so a
			// second jQuery UI theme on the page can't fight over it).
			var $title = $p.find('.mk-ui-modal__title');
			if (title) {
				$title.text(title).css('display', '');
			} else {
				$title.empty().css('display', 'none');
			}

			$p.find('.mk-ui-modal__content').html(content);
			$p.find('.mk-ui-modal__actions').empty();

			var classes = 'mk-ui-modal' + (options.classes ? ' ' + options.classes : '');
			$p.dialog('option', {
				title: '',
				width: options.width || 'auto',
				classes: { 'ui-dialog': classes },
			});

			$p.off('dialogopen.mkui dialogclose.mkui');
			if (typeof options.onOpen === 'function') {
				$p.on('dialogopen.mkui', options.onOpen);
			}
			if (typeof options.onClose === 'function') {
				$p.on('dialogclose.mkui', options.onClose);
			}

			$p.dialog('open');
			$p.dialog('option', 'position', { my: 'center', at: 'center', of: window });
		},
		close: function () {
			if ($placeholder && $placeholder.hasClass('ui-dialog-content')) {
				$placeholder.dialog('close');
			}
		},
		setContent: function (html) {
			if ($placeholder) {
				$placeholder.find('.mk-ui-modal__content').html(html);
			}
		},
		setActions: function (html) {
			if ($placeholder) {
				$placeholder.find('.mk-ui-modal__actions').html(html);
			}
		},
	};

	window.MkUi = MkUi;
})(jQuery);
